import React, { useState } from 'react';
import { 
  Mail, 
  Inbox, 
  Settings, 
  BarChart3,
  Users,
  Plus,
  Bot,
  FileText,
  ChevronLeft,
  ChevronRight,
  LogOut,
  User,
  MessageSquare
} from 'lucide-react';
import { cn } from '../../utils';
import Button from '../ui/Button';
import ThemeToggle from '../ui/ThemeToggle';
import { useAuth } from '../../contexts/AuthContext';

interface SidebarProps {
  currentPage: string;
  onPageChange: (page: string) => void;
  onComposeEmail?: () => void;
  unreadCount?: number;
}

const Sidebar: React.FC<SidebarProps> = ({ currentPage, onPageChange, onComposeEmail, unreadCount = 0 }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { logout } = useAuth();

  const menuItems = [
    {
      id: 'chat',
      label: '用户反馈',
      icon: MessageSquare,
      primary: true
    },
    {
      id: 'sender-rules',
      label: '用户管理',
      icon: Users,
    },
    // {
    //   id: 'ai-assistants',
    //   label: 'AI助手',
    //   icon: Bot,
    // },
    // {
    //   id: 'ai-reports',
    //   label: 'AI日报',
    //   icon: FileText,
    // },
    // {
    //   id: 'settings',
    //   label: '设置',
    //   icon: Settings,
    // }
  ];

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className={cn(
      "theme-bg-primary theme-border-primary border-r flex flex-col h-full transition-all duration-300 ease-in-out theme-transition",
      isCollapsed ? "w-16" : "w-30"
    )}>
      {/* Logo区域 */}
      <div className={cn(
        "border-b theme-border-primary flex items-center justify-between",
        isCollapsed ? "p-3" : "p-4"
      )}>
        {!isCollapsed && (
          <div className="flex items-center space-x-3">
            <div>
              <h1 className="text-lg font-semibold theme-text-primary">用户系统</h1>
            </div>
          </div>
        )}
        
        {/* 折叠/展开按钮 */}
        <button
          onClick={toggleCollapse}
          className={cn(
            "p-1.5 rounded-lg theme-bg-hover theme-transition",
            isCollapsed ? "mx-auto mt-2" : ""
          )}
          title={isCollapsed ? "展开侧边栏" : "折叠侧边栏"}
        >
          {isCollapsed ? (
            <ChevronRight className="w-4 h-4 theme-text-secondary" />
          ) : (
            <ChevronLeft className="w-4 h-4 theme-text-secondary" />
          )}
        </button>
      </div>

      {/* 撰写按钮 */}
      {/* <div className={cn("p-4", isCollapsed && "px-2")}>
        {isCollapsed ? (
          <button
            onClick={onComposeEmail}
            className="w-full h-10 bg-blue-600 hover:bg-blue-700 rounded-lg flex items-center justify-center transition-colors"
            title="撰写邮件"
          >
            <Plus className="w-4 h-4 text-white" />
          </button>
        ) : (
          <Button className="w-full justify-start" size="lg" onClick={onComposeEmail}>
            <Plus className="w-4 h-4 mr-2" />
            撰写邮件
          </Button>
        )}
      </div> */}

      {/* 导航菜单 */}
      <nav className={cn("flex-1 space-y-1 mt-4", isCollapsed ? "px-2" : "px-4")}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPage === item.id;
          
          if (isCollapsed) {
            return (
              <button
                key={item.id}
                onClick={() => onPageChange(item.id)}
                className={cn(
                  'w-full h-10 flex items-center justify-center rounded-lg relative group theme-transition',
                  isActive
                    ? 'theme-nav-active'
                    : 'theme-nav-item theme-bg-hover'
                )}
                title={item.label}
              >
                <Icon className={cn(
                  'w-5 h-5',
                  isActive ? 'theme-blue-text' : 'theme-text-secondary'
                )} />
                
                {/* 悬浮提示 */}
                <div className="absolute left-full ml-2 px-2 py-1 theme-bg-tertiary theme-text-primary text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 theme-shadow-md">
                  {item.label}
                  
                </div>
              </button>
            );
          }
          
          return (
            <button
              key={item.id}
              onClick={() => onPageChange(item.id)}
              className={cn(
                'w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium rounded-lg theme-transition',
                isActive
                  ? 'theme-nav-active'
                  : 'theme-nav-item theme-bg-hover'
              )}
            >
              <div className="flex items-center space-x-3">
                <Icon className={cn(
                  'w-5 h-5',
                  isActive ? 'theme-blue-text' : 'theme-text-secondary'
                )} />
                <span>{item.label}</span>
              </div>
            </button>
          );
        })}
      </nav>

      {/* 主题切换按钮 */}
      <div className={cn("border-t theme-border-primary p-4", isCollapsed && "px-2")}>
        {isCollapsed ? (
          <ThemeToggle 
            variant="icon" 
            size="sm"
            className="w-full h-10 flex items-center justify-center"
          />
        ) : (
          <ThemeToggle 
            size="sm"
            className="w-full justify-start"
            showLabel={true}
          />
        )}
      </div>
    </div>
  );
};

export default Sidebar; 